import * as fbq from '../../lib/fbpixel';
import axios from 'axios';
import { Container } from '../common/AltCard';
import { Link } from 'react-router-dom';
    const stagingEnpoint = 'https://stagingapi.pakam.ng/api/facebook/notify'
const Empower = () => {



  return (
    <Container>
        <div className='shadowM pl-4 py-4 lg:py-0 w-full bg-[#D9D9EE] rounded-lg md:rounded-[32px] my-10 md:pl-[40px] flex justify-between items-center '>
            <div>
                <h1 className=' font-[800] text-[20px] md:text-[44px] lg:text-[46px] text-[#35393F] tracking-[-4%] leading-[36px]  md:leading-[50px] font-rob'>Grow Your Recycling Business<br />with Us </h1>
                {/* <p className='hidden lg:block text-[#444951] font-[600] text-[20px] md:text-[36px] text-center font-Rob '>Earn and save the environment</p> */}
                <p className='hidden lg:block text-[#0F172A] text-[14px] font-[400] lg:w-[55%] pt-6 font-Rob'>Whether you're an individual, a corporate business, school, or an estate, Pakam makes waste recycling simple, rewarding, and impactful.</p>
                <PerkList perks={conpiledPerks.users}/>
                  <div className='flex space-x-10'>
                    <Link to='/onboarding' className='text-white text-center hover:font-[600] font-[400] px-8 py-2 mr-2 rounded-[3rem] bg-primary border-1 border-primary'>Register as a Recycler</Link>
                  </div>   
                
          
            </div>
            <div className='hidden lg:block  h-full'>
                <img src="/img/whyPk.png" className='h-full' alt="" />
            </div>

        </div>     
    </Container>
  )
}

export default Empower


export const Expand =()=>{

      const handleDownloadAndroid= async() => {
      fbq.event('Download', { device: 'Andriod' })
      
      try {
        const res = await axios.post(stagingEnpoint, {
          headers: {
            'Content-Type': 'application/json'
          }
        });
      } catch (error) {
        console.log(error)
      }
    }
  
    const handleDownloadIOS= async() => {
      fbq.event('Download', { device: 'IOS' })
      
      try {
        const res = await axios.post(stagingEnpoint, {
          headers: {
            'Content-Type': 'application/json'
          }
        });
      } catch (error) {
        console.log(error)
      }
    }
  return (
    <Container>
        <div className='shadowM pl-4 py-4 lg:py-0 w-full bg-[#DDEEE0] rounded-lg md:rounded-[32px] my-10 md:pl-[40px] flex justify-between items-center '>
            <div className='w-3/4'>
                <h1 className=' font-[800] text-[20px] md:text-[44px] lg:text-[46px] text-[#35393F] tracking-[-4%] leading-[36px]  md:leading-[50px] font-rob'>Turn your trash into impact. <br />Dispose and earn rewards!</h1>
                  <PerkList perks={conpiledPerks.users}/>                
                  <div className='flex space-x-8'>
                        <a  href="https://play.google.com/store/apps/details?id=com.pakamcustomer">
                        <button onClick={handleDownloadAndroid}>
                            <img className='md:h-[50px] md:w-[180px] h-[40px] w-[130px]' src="/img/get-it-on-google-play-badge.png" alt="" />
                        </button></a>
                        <a  href="https://apps.apple.com/ng/app/pakam-household-recycling-app/id1539296957">
                        <button onClick={handleDownloadIOS}>
                            <img className='md:h-[50px] md:w-[180px] h-[40px] w-[130px]' src="/img/app store badge.png" alt="" />
                        </button></a>

                    </div>             
            </div>
            <div className='hidden lg:block h-full'>
                <img src="/img/userImg.png" className='h-full' alt="" />
            </div>

        </div>     
    </Container>
  )}
  
export const Build =()=>{
  return (
    <Container>
        <div className='shadowM pl-4 py-4 lg:py-0 w-full bg-[#E8FAEE] rounded-lg md:rounded-[32px] my-10 md:pl-[40px] flex justify-between items-center '>
            <div className='w-3/4'>
                <h1 className=' font-[800] text-[20px] md:text-[44px] lg:text-[46px] text-[#35393F] tracking-[-4%] leading-[36px]  md:leading-[50px] font-rob'>Build a More Sustainable & <br />Profitable Future</h1>
                <PerkList perks={conpiledPerks.users}/>
                <div className='flex space-x-10'>
                    <Link to='/be-your-own-boss' className='text-white hover:font-[600] font-[400] px-8 py-2 mr-2 rounded-[3rem] bg-primary border-1 border-primary'>Partner With Us</Link>
                    </div>                
            </div>
            <div className='hidden lg:block  h-full'>
                <img src="/img/partnerImg.png" className=' h-full' alt="" />
            </div>

        </div>     
    </Container>
  )}


export const Elevate =()=>{
  return (
    <Container>
        <div className='shadowSM w-full bg-[#E8FAEE] rounded-lg md:rounded-[32px] my-10 md:pl-[40px] flex justify-center items-center flex-col '>
                <h1 className=' font-[600] text-center text-[20px] md:text-[44px] lg:text-[46px] text-primary tracking-[-4%] leading-[36px]  md:leading-[50px] font-rob'>Ready to elevate your platform?</h1>
                {/* <p className='hidden lg:block text-[#444951] font-[600] text-[20px] md:text-[36px] text-center font-Rob '>Earn and save the environment</p> */}
                <p style={{color:'rgba(1, 29, 1, 0.7)'}} className=' text-center text-[18px] font-[500] lg:w-[55%] py-6 font-Rob'>Fast-track your development today! Integrate our APIs to streamline your building process and achieve your goals sooner.</p>
                <div className='flex'>
                    <Link to='/contact-us' className='text-white hover:font-[600] font-[400] px-8 py-2 mr-2 rounded-[3rem] bg-primary border-1 border-primary'>Contact Us to Get Started</Link>
                    </div>                

        </div>     
    </Container>
  )}


type PerkListProps = {
  perks: string[];
};

const PerkList: React.FC<PerkListProps> = ({ perks }) => {
  return (
    <div className='py-6'>
      {perks.map((perk, id) => (
        <div key={id} className="flex items-start gap-2 mb-2">
          <img src="/img/tick.png" alt="tick icon" className="w-4 h-4 mt-1" />
          <span className='text-[14px]'>{perk}</span>
        </div>
      ))}
    </div>
  );
};



  const conpiledPerks = {
    recyclers:[
        'Pay for recyclable materials on the spot using your Pakam wallet',
'Track every KG collected, traded, and processed—digitally and in real-time.',
'Need cash to buy more waste? Get pre-approved micro-loans through the app.'
      ],
    users:[
        'Discounts on future pickups when recycling is sorted correctly.',
        'Loyalty points for each scheduled pickup or proper sorting.',
        'Badges/certificates for households that meet monthly recycling goals.'
      ],
    partners:[
        'Connect with More Waste Generators – Boost Revenue Today',
        'Recycling Just Got Smarter – Join the Fastest-Growing Waste Banking Network',
        'Connect to a steady flow of recyclable waste from households & businesses.'
      ],
  }